import React, { useMemo, useState } from 'react';
import KitplaySettingForm from '@components/common/form/KitplaySettingModal/KitplaySettingForm';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { showErrorMessage, showSucsessMessage } from '@services/notifyService';
import { parseSettings } from '@utils';
import { Checkbox, Flex, Modal } from 'antd';

function KitplaySettingModal({ open, record, onClose, onSuccess }) {
    const translate = useTranslate();
    const [isChanged, setIsChanged] = useState(false);
    const [applyForAll, setApplyForAll] = useState(false);

    const settingObj = useMemo(() => parseSettings(record?.settings), [record]);

    const { execute: updateSettings, loading: loadingUpdate } = useFetch(apiConfig.printer.updateSettings);

    const handleClose = () => {
        setIsChanged(false);
        setApplyForAll(false);
        onClose?.();
    };

    const handleSaveSettings = ({ lateTime, groupTakeAway, groupDelivery, foodBreakCount }) => {
        if (!record) return;
        updateSettings({
            data: {
                id: record.printer?.id,
                settings: JSON.stringify({
                    late_time: Number(lateTime),
                    group_take_away: groupTakeAway,
                    group_delivery: groupDelivery,
                    food_break_count: foodBreakCount && Number(foodBreakCount),
                    win_print: settingObj?.win_print,
                }),
                applyForAll,
            },
            onCompleted: () => {
                showSucsessMessage(translate.formatMessage(commonMessage.success), translate);
                handleClose();
                onSuccess?.();
            },
            onError: () => {
                showErrorMessage(translate.formatMessage(commonMessage.error), translate);
            },
        });
    };

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            footer={null}
            title={
                <Flex align="center" justify="space-between" gap={16} style={{ width: '100%', paddingRight: 24 }}>
                    <span>{translate.formatMessage(commonMessage.kitplaySettings)}</span>
                    <Checkbox
                        checked={applyForAll}
                        onChange={(e) => {
                            setApplyForAll(e.target.checked);
                            setIsChanged(true);
                        }}
                        style={{ fontWeight: 'normal' }}
                    >
                        {translate.formatMessage(commonMessage.applyForAllDevice)}
                    </Checkbox>
                </Flex>
            }
            width={520}
            destroyOnClose
            maskClosable={false}
            style={{ top: 50 }}
            styles={{
                body: {
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    paddingRight: '2px',
                },
            }}
        >
            {record && (
                <KitplaySettingForm
                    formId="kitplay-setting-form"
                    settingObj={settingObj}
                    onSubmit={handleSaveSettings}
                    setIsChangedFormValues={setIsChanged}
                    isChangedFormValues={isChanged}
                    loadingUpdate={loadingUpdate}
                />
            )}
        </Modal>
    );
}

export default KitplaySettingModal;